/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ProtocolSettings,
  ProtocolSettingsInterface,
} from "../ProtocolSettings";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "superAdmin",
        type: "address",
      },
      {
        internalType: "address",
        name: "_backendSigner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newBackendSigner",
        type: "address",
      },
    ],
    name: "UpdateBackendSigner",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "backendSigner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newBackendSigner",
        type: "address",
      },
    ],
    name: "updateBackendSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ProtocolSettings__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    superAdmin: string,
    _backendSigner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ProtocolSettings> {
    return super.deploy(
      superAdmin,
      _backendSigner,
      overrides || {}
    ) as Promise<ProtocolSettings>;
  }
  getDeployTransaction(
    superAdmin: string,
    _backendSigner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      superAdmin,
      _backendSigner,
      overrides || {}
    );
  }
  attach(address: string): ProtocolSettings {
    return super.attach(address) as ProtocolSettings;
  }
  connect(signer: Signer): ProtocolSettings__factory {
    return super.connect(signer) as ProtocolSettings__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ProtocolSettingsInterface {
    return new utils.Interface(_abi) as ProtocolSettingsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ProtocolSettings {
    return new Contract(address, _abi, signerOrProvider) as ProtocolSettings;
  }
}
